import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Chart, ChartItem } from 'chart.js';
import {
  DEFAULT_CHART_BACKGROUNDS,
  DEFAULT_CHART_BORDERS,
  DEFAULT_CHART_LABELS,
  DEFAULT_CHART_BAR_OPTIONS,
  DEFAULT_CHART_PIE_OPTIONS,
} from './chart-defaults';
import { CHART_TYPE } from './chart.constants';
import { registerChartPlugins } from './chart.registration';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  imports: [CommonModule, IonicModule],
})
export class ChartComponent implements OnInit, AfterViewInit {
  @Input() title: string = '';
  @Input() chartType: CHART_TYPE = CHART_TYPE.PIE;
  @Input() chartData: number[] = [];
  @Input() chartBackgrounds: string[] = DEFAULT_CHART_BACKGROUNDS;
  @Input() chartBorders: string[] = [];
  @Input() chartLabels: string[] = [];
  @Input() chartOptions: Record<string, unknown> = {};
  @ViewChild('myChart', { static: false })
  myChart: ElementRef<HTMLCanvasElement> | undefined;

  public chart: Chart | undefined;
  public isBar: boolean | undefined;

  constructor() {
    registerChartPlugins();
  }

  updateChart(newData: number[]) {
    if (this.chart) {
      this.chart.data.datasets[0].data = newData;
      this.chart.update();
    }
  }

  ngOnInit() {
    this.chartType = this.chartType || CHART_TYPE.PIE;
    this.isBar = this.chartType === CHART_TYPE.BAR;
    this.title = this.title || 'Net Profit';
    this.chartData = this.chartData || [1, 2, 3];
    this.chartBorders = this.chartBorders || [DEFAULT_CHART_BORDERS[0]]; // only using green atm
    this.chartLabels = this.chartLabels || DEFAULT_CHART_LABELS;

    if (this.chartType === CHART_TYPE.PIE) {
      this.chartOptions = DEFAULT_CHART_PIE_OPTIONS;
    } else {
      this.chartOptions = DEFAULT_CHART_BAR_OPTIONS;
      this.chartOptions['scales'] = {
        x: {
          beginAtZero: false,
          ticks: {
            callback: (label: number) =>
              '$' +
              Math.floor(label / 1000)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
              'k',
          },
        },
      };
    }
  }

  ngAfterViewInit() {
    this.chart = new Chart(
      this.myChart?.nativeElement.getContext('2d') as ChartItem,
      {
        type: this.chartType,
        data: {
          labels: this.chartLabels,
          datasets: [
            {
              label: this.title,
              data: this.chartData,
              backgroundColor: this.chartBackgrounds,
              borderColor: 'white', //this.chartBorders,
              borderWidth: 1,
            },
          ],
        },
        options: {
          ...this.chartOptions,
          indexAxis: 'y',
          plugins: {
            legend: {
              display: true, //!this.isBar,
              position: 'bottom' as const,
            },
            datalabels: {
              align: 'center',
              display: true,
              color: 'white',
              clip: false,
              font: {
                weight: 'bold' as const,
                size: 14,
              },
              formatter: (value: number) =>
                '$' +
                Math.floor(Number(value) / 1000).toLocaleString('en-US') +
                'k',
            },
          },
          animation: {
            duration: 800,
            easing: 'easeInOutQuart',
          },
        },
      },
    ) as Chart;
  }
}
